module.exports = [{
      plugin: require('/Users/patrick/croustille/anne-savage/anne-savage/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":590},
    },{
      plugin: require('/Users/patrick/croustille/anne-savage/anne-savage/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/patrick/croustille/anne-savage/anne-savage/node_modules/gatsby-plugin-intl/gatsby-browser.js'),
      options: {"plugins":[],"path":"/Users/patrick/croustille/anne-savage/anne-savage/src/intl","languages":["en","fr"],"defaultLanguage":"fr","redirect":false},
    },{
      plugin: require('/Users/patrick/croustille/anne-savage/anne-savage/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-140911866-1","head":false,"anonymize":true,"respectDNT":true},
    },{
      plugin: require('/Users/patrick/croustille/anne-savage/anne-savage/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
